
  import { COOKIE_SELECTED_PRODUCT } from '@/constants/cookies';
  import { productToCookie } from '@/scripts/utils';
  import { mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters('products', { card: 'get' })
    },
    methods: {
      saveToCookies () {
        this.$cookies.set(COOKIE_SELECTED_PRODUCT, productToCookie(this.card));
      }
    }
  };
